<!-- No backdrop-tap dismissal and no corner X: "Maybe later" is the single, deliberate no. -->
<div class="push-prompt-overlay" *ngIf="isOpen" @fadeIn>
  <div class="push-prompt-modal">
    <div class="prompt-icon">
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z" fill="var(--menu-text, #FFFFFF)"/>
      </svg>
    </div>

    <!--
      One message, whatever the diner had just been browsing. The per-source variants argued from
      Explore or Events specifically ("Offers, straight to your phone"), which stopped being true
      once a touristic venue started sending an event and an attraction rather than offers.
      The order ask is the exception: it is a different question, asked from the Order button.
    -->
    <p class="prompt-title">{{ (isOrderAsk ? 'orderPushPrompt.title' : 'pushPrompt.title') | translate }}</p>
    <p class="prompt-subtitle">{{ (isOrderAsk ? 'orderPushPrompt.subtitle' : 'pushPrompt.subtitle') | translate }}</p>

    <button class="enable-btn" (click)="enableNotifications()" [disabled]="isLoading">
      <ng-container *ngIf="!isLoading; else loadingTpl">
        {{ (isOrderAsk ? 'orderPushPrompt.enableButton' : 'pushPrompt.enableButton') | translate }}
      </ng-container>
      <ng-template #loadingTpl>
        <div class="spinner"></div>
      </ng-template>
    </button>

    <button class="dismiss-btn" (click)="dismiss()">
      {{ (isOrderAsk ? 'orderPushPrompt.dismissButton' : 'pushPrompt.dismissButton') | translate }}
    </button>
  </div>
</div>
